import styled from "@emotion/styled";
import fuzzySort from "fuzzysort";
import React from "react";
import { fontWeight } from "../../../typography/constants/typographyConstants";
import { BaseOptionType, OptionToString } from "../../types";

export type FuzzySearchResultProps<Option extends BaseOptionType> = {
    inputValue: string;
    option: Option;
    optionToString: OptionToString<Option>;
};

export const FuzzySearchResult = <Option extends BaseOptionType>(
    props: FuzzySearchResultProps<Option>
): JSX.Element => {
    const { optionToString, option, inputValue } = props;
    const optionAsString = optionToString(option);
    let optionLabel: (string | JSX.Element)[] | null = [optionAsString];
    const result = fuzzySort.single(inputValue, optionAsString);
    if (result) {
        optionLabel = fuzzySort.highlight(result, (match, key) => (
            <FuzzySearchMatchStyled key={key}>{match}</FuzzySearchMatchStyled>
        ));
    }
    return <>{optionLabel}</>;
};

const FuzzySearchMatchStyled = styled("span")`
    font-weight: ${fontWeight.extraBold};
    display: inline-block;
`;
